import { render, staticRenderFns } from "./buttonTemplateItem.vue?vue&type=template&id=4841b3ec&scoped=true&"
import script from "./buttonTemplateItem.vue?vue&type=script&lang=js&"
export * from "./buttonTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./buttonTemplateItem.vue?vue&type=style&index=0&id=4841b3ec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841b3ec",
  null
  
)

export default component.exports